import Menus from "@/components/menus/Menus";
import Pagination from "@/components/pagination/Pagination";
import { getMenus } from "@/services/menuService";
import { MenuJsonItem } from "@/types/types";
import { capitalizeText } from "@/utilities/menu";
import Head from "next/head";
import { useRouter } from "next/router";

interface PageProps {
  menus: MenuJsonItem[];
  cuisineType: string;
  currentPage: number;
  totalPages: number;
}

export async function getServerSideProps(
  context: any
): Promise<{ props?: PageProps; notFound?: boolean }> {
  const { cuisine, page = 1, limit = 51 } = context.query;

  let response = await getMenus(
    "",
    parseInt(page),
    parseInt(limit),
    undefined,
    undefined,
    cuisine
  );

  const cuisineTypeText = cuisine ? capitalizeText(cuisine) : "";

  return {
    props: {
      menus: response.data,
      cuisineType: cuisineTypeText,
      currentPage: response.currentPage,
      totalPages: response.totalPages,
    },
  };
}

const MenusPagePerCuisine: React.FC<PageProps> = ({
  menus,
  cuisineType,
  currentPage,
  totalPages,
}) => {
  const router = useRouter();

  const handlePageChange = (newPage: number) => {
    router.push({
      pathname: router.pathname,
      query: { ...router.query, page: newPage },
    });
  };

  return (
    <div>
      <Head>
        <title>
          Top {cuisineType} Cuisine Restaurants. Local Restaurants on QRMenu.com
        </title>
        <meta
          name="description"
          content={`Connect with the ultimate ${cuisineType} cuisine experiences at local restaurants. From classic to contemporary ${cuisineType} styles, discover a world of taste and tradition.`}
        />
      </Head>
      <div
        className="bg-cover bg-center min-h-[35vh] flex items-center justify-center py-20"
        style={{
          backgroundImage: `url('https://dopweb-repository.s3.us-west-2.amazonaws.com/qrmenu/mydop-images/img5d5db67a-221c-4e9d-87fb-f2d56bd9a51e.webp')`,
        }}
      >
        <div className="container mx-auto text-center">
          <div className="flex flex-wrap justify-center">
            <div className="w-full px-4">
              <h1 className="text-4xl font-bold text-black mb-4">
                Discover Top {cuisineType} Cuisine Restaurants
              </h1>
              <p className="text-xl text-black">
                Savor the Art of {cuisineType} Cuisine at Our Premier
                Restaurants!
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 mb-12 max-w-[1225px]">
        <h2 className="text-2xl font-semibold text-center my-8">
          Discover {cuisineType} Perfection: Savor the Best in Restaurant
          Cuisine
        </h2>
        <Menus menus={menus} />

        <Pagination currentPage={currentPage} totalPages={totalPages} />
      </div>
    </div>
  );
};

export default MenusPagePerCuisine;
